/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Credentials_In_UrlInputs */

const en_site_url_error_credentials_in_url = /** @type {(inputs: Site_Url_Error_Credentials_In_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the username/password from the address.`)
};

const id_site_url_error_credentials_in_url = /** @type {(inputs: Site_Url_Error_Credentials_In_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus nama pengguna/kata sandi dari alamat.`)
};

/**
* | output |
* | --- |
* | "Remove the username/password from the address." |
*
* @param {Site_Url_Error_Credentials_In_UrlInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_credentials_in_url = /** @type {((inputs?: Site_Url_Error_Credentials_In_UrlInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Credentials_In_UrlInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_credentials_in_url(inputs)
	return en_site_url_error_credentials_in_url(inputs)
});